import { makeScalarToken } from './token.scalar.js';
import { makeGenericToken } from './util.make-generic-token.js';

function makeFontToken(propName, input) {
  const tokens = Object.fromEntries(Object.entries(input.fontFaces).map(([key, [fontFamily, fontWeight]]) => {
    return [key, {
      family: makeScalarToken(`${propName}--${key}--font-family`, fontFamily),
      weight: makeScalarToken(`${propName}--${key}--font-weight`, fontWeight)
    }];
  }));
  return makeGenericToken(function format(options) {
    const key = options?.weight ?? input.default;
    const fontFace = tokens[key];
    const priority = options?.priority === "important" ? " !important" : "";
    return `${fontFace.family()}${priority};font-weight:${fontFace.weight()}${priority}`;
  }, function override(nextValue) {
    if (nextValue === undefined) {
      return {};
    }
    if ("__override" in nextValue) {
      return Object.keys(nextValue.fontFaces).reduce((acc, key) => {
        return {
          ...acc,
          ...tokens[key].family.__override(nextValue.fontFaces[key].family),
          ...tokens[key].weight.__override(nextValue.fontFaces[key].weight)
        };
      }, {});
    }
    return Object.keys(nextValue).reduce((acc, key) => {
      const [fontFamily, fontWeight] = nextValue[key] ?? [];
      return {
        ...acc,
        ...tokens[key].family.__override(fontFamily),
        ...tokens[key].weight.__override(fontWeight)
      };
    }, {});
  }, function extend(propName) {
    const prevTokens = Object.fromEntries(Object.entries(tokens).map(([key, value]) => [key, [value.family(), value.weight()]]));
    return makeFontToken(propName, {
      fontFaces: prevTokens,
      default: input.default
    });
  }, {
    fontFaces: tokens,
    default: tokens[input.default]
  });
}

export { makeFontToken };
//# sourceMappingURL=token.font.js.map
